const secoes = ['Resumo', 'Estatisticas', 'Distribuicoes', 'Simulador'];

// Aceita tanto rodadas completas do storage quanto os JSONs exportados anteriormente.
export const importarRodada = (arquivo) => {
    const resultados = arquivo?.resultados ?? arquivo;
    if (!resultados || typeof resultados !== 'object' || Array.isArray(resultados)
        || !secoes.some(secao => resultados[secao] && typeof resultados[secao] === 'object')) {
        throw new Error('O arquivo não contém resultados de uma rodada do DIno.');
    }

    let filtros = arquivo.resultados ? arquivo.filtros : null;
    if (!filtros && resultados.filtrosAplicados) {
        const antigos = resultados.filtrosAplicados;
        filtros = {
            trlInitial: antigos.parametros?.TRL?.inicial ?? 1,
            trlFinal: antigos.parametros?.TRL?.final ?? 9,
            crlInitial: antigos.parametros?.CRL?.inicial ?? 1,
            crlFinal: antigos.parametros?.CRL?.final ?? 9,
            innovationDegree: Object.fromEntries([1, 2, 3].map(grau => [grau, (antigos.grauInovacao || []).includes(grau)])),
            typology: antigos.tipologia || [],
            status: antigos.status || [],
            portfolio: antigos.portfolio || [],
            technologicalInitiative: antigos.iniciativaTecnologica || [],
            category: antigos.categoria || [],
            dataMin: antigos.dataMin || '',
            dataMax: antigos.dataMax || '',
            previsoes: antigos.previsoes || false,
        };
    }
    if (filtros != null && (typeof filtros !== 'object' || Array.isArray(filtros))) {
        throw new Error('Os filtros da rodada são inválidos.');
    }
    return {
        resultados,
        filtros: filtros ?? null,
        dataReferencia: typeof arquivo.dataReferencia === 'string' ? arquivo.dataReferencia : '',
    };
};
